<template>
    <section class="log-in-or-register-chooser">
        <div class="log-in-or-register-chooser__container">
            <h2 class="log-in-or-register-chooser__title">
                {{ this.$scheme.resources.app.introText }}
            </h2>
            <p class="log-in-or-register-chooser__text">
                If you already have an account with us please log in, if not you can register here.
            </p>
            <div class="log-in-or-register-chooser__buttons --modal-buttons">
                <hh-btn def="log-in-or-register-chooser-login-btn"
                        class="log-in-or-register-chooser__buttons__login"
                        icon-class="fas fa-sign-in-alt"
                        icon-location="pre"
                        text="Log In"
                        @click="onClickLogIn" />
                <hh-btn def="log-in-or-register-chooser-register-btn"
                        class="log-in-or-register-chooser__buttons__register"
                        icon-class="fas fa-user-plus"
                        icon-location="pre"
                        text="Register"
                        @click="onClickRegister" />
            </div>
        </div>
    </section>
</template>

<script>

import Vuex from 'vuex'

import LogInConfirmation from './log-in-confirmation'

export default {

    computed: {

        ...Vuex.mapState({
            /**
             * @param {VuexState} stateStore
             * @returns {Project}
             */
            currentProject: stateStore => stateStore.improvements.currentProject,
        }),

        stateIsClean() {
            return !this.currentProject || !this.currentProject.initialised
        },
    },

    methods: {

        onClickLogIn(ev) {
            if (this.stateIsClean) {
                this.$eventbus.$emit(this.$appevents.hideModalWithoutActions, ev)
                if (this.$router.invalidRedirects.includes(this.$route.name))
                    this.$router.push({ name: 'LogIn' })
                else
                    this.$router.push({ name: 'LogIn', params: { redirect: this.$route } })
            } else {
                this.$eventbus.$emit(this.$appevents.showModal, LogInConfirmation)
            }
        },

        onClickRegister(ev) {
            this.$eventbus.$emit(this.$appevents.hideModalWithoutActions, ev)
            if (this.$router.invalidRedirects.includes(this.$route.name))
                this.$router.push({ name: 'Register' })
            else
                this.$router.push({ name: 'Register', params: { redirect: this.$route } })
        },
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\components\improvements\modals\_log-in-or-register-chooser.scss

.log-in-or-register-chooser {

    @include element('title') {
        margin: 0 0 0.6em 0;
        line-height: 1.2em;
    }

    @include element('text') {
        text-align: center;
    }

    @include element('buttons') {
        padding-top: 10px;
        width: 100%;
        display: flex;
        justify-content: space-evenly;
    }
}

</style>
